export default __webpack_public_path__ + "static/media/announcement_2@3x.d840f62b.png";